/* 🤖 this file was generated by svg-to-ts */
export const matIconBalcony: {
  name: 'balcony';
  data: string;
} = {
  name: 'balcony',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 10v2H8v-2h2zm6 2v-2h-2v2h2zm5 2v8H3v-8h1v-4c0-4.42 3.58-8 8-8s8 3.58 8 8v4h1zM7 16H5v4h2v-4zm4 0H9v4h2v-4zm0-11.92C8.16 4.56 6 7.03 6 10v4h5V4.08zM13 14h5v-4c0-2.97-2.16-5.44-5-5.92V14zm2 2h-2v4h2v-4zm4 0h-2v4h2v-4z"/></svg>`
};
